import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPackagingGroup, IPackagingGroupState } from "./packaginggroupModel";
import {
  createPackagingGroup,
  deletePackagingGroup,
  getAllActivePackagingGroup,
  getAllPackagingGroup,
  getPackagingGroupByID,
  PackagingGroupActiveInactive,
  updatePackagingGroup,
} from "./services/packaginggroup.services";

const initialState: IPackagingGroupState = {
  loading: false,
  formLoading: false,
  error: "",
  PackagingGroupList: [],
  PackagingGroupID: null,
  PackagingGroupDetail: {
    packaging_group: "",
    isactive: 1,
  },
};

const packaginggroupSlice = createSlice({
  name: "packaginggroup",
  initialState,
  reducers: {
    clearPackagingGroupDetails: (state) => {
      state.PackagingGroupDetail = initialState.PackagingGroupDetail;
    },
    setPackagingGroupID: (state, action) => {
      state.PackagingGroupID = action.payload;
    },
    clearPackagingGroupID: (state) => {
      state.PackagingGroupID = initialState.PackagingGroupID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllPackagingGroup.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllPackagingGroup.fulfilled,
      (state, action: PayloadAction<IPackagingGroup[]>) => {
        state.loading = false;
        state.PackagingGroupList = action.payload || [];
      }
    );
    builder.addCase(getAllPackagingGroup.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PackagingGroupList = [];
    });
    builder.addCase(getAllActivePackagingGroup.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActivePackagingGroup.fulfilled,
      (state, action: PayloadAction<IPackagingGroup[]>) => {
        state.loading = false;
        state.PackagingGroupList = action.payload || [];
      }
    );
    builder.addCase(getAllActivePackagingGroup.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PackagingGroupList = [];
    });
    builder.addCase(createPackagingGroup.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createPackagingGroup.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createPackagingGroup.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updatePackagingGroup.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updatePackagingGroup.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updatePackagingGroup.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deletePackagingGroup.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deletePackagingGroup.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deletePackagingGroup.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(PackagingGroupActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(PackagingGroupActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(PackagingGroupActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getPackagingGroupByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getPackagingGroupByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.PackagingGroupDetail = action.payload;
    });
    builder.addCase(getPackagingGroupByID.rejected, (state, action) => {
      state.formLoading = false;
      state.PackagingGroupDetail = initialState.PackagingGroupDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearPackagingGroupDetails,
  setPackagingGroupID,
  clearPackagingGroupID,
} = packaginggroupSlice.actions;
export default packaginggroupSlice.reducer;
